import { render, staticRenderFns } from "./employeePage.vue?vue&type=template&id=71fbca66"
import script from "./employeePage.vue?vue&type=script&lang=js"
export * from "./employeePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports